import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";

import { emit } from "@/internals/events";

import { WithTooltipMixin, type WithTooltipProps } from "@/internals/mixins/with-tooltip-mixin";

import AtlasElement, { type AtlasElementProps } from "@/components/atlas-element";
import styles from "./atlas-image-preview-control.scss";

import "@/components/display/atlas-icon/atlas-icon";

export type ImagePreviewControlProps = AtlasElementProps &
    WithTooltipProps & {
        icon: string;
        disabled: boolean;
    };

/**
 * @tag atlas-image-preview-control
 */
@customElement("atlas-image-preview-control")
export default class AtlasImagePreviewControl extends WithTooltipMixin(AtlasElement) {
    static styles = styles;

    /** Ícone do controlador das imagens */
    @property({ type: String }) icon: string;

    /** Indica se está desabilitado */
    @property({ type: Boolean, reflect: true }) disabled: boolean;

    onClick(event: MouseEvent) {
        event.preventDefault();
        event.stopPropagation();

        emit(this, "atlas-image-preview-control-click");
    }

    render() {
        const atlasImagePreviewControlClass= {
            "atlas-image-preview-control": true,
            "disabled": this.disabled
        };

        return html`
            <button
                data-atlas-tooltip="image-preview-control-tooltip"
                class="${classMap(atlasImagePreviewControlClass)}"
                @click=${this.onClick}
            >
                <atlas-icon name="${this.icon}" size="2x"></atlas-icon>
            </button>
            ${this.renderTooltip("image-preview-control-tooltip")}
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "atlas-image-preview-control": AtlasImagePreviewControl;
    }
}
